import { useFormState } from 'informed';
import { useReduxState } from 'hooks';
import { Switch } from 'components/common/form';
import { InfoCountTileContent } from 'components/common/info';
import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  category: 'warning' | 'default';
  field: string;
  icon: IconProp;
  id: string;
  label: string;
  text: string;
}

const HomePageSettingsSummaryCount = ({
  category,
  field,
  icon,
  id,
  label,
  text
}: Props) => {
  const { values } = useFormState();

  const { theme } = useReduxState();

  return (
    <div className="count">
      <div className="switch">
        <Switch field={field} id={id} label={label} />
      </div>

      <div className={`preview ${values?.[field] ? '' : 'preview-disabled'}`}>
        <div className="content">
          <InfoCountTileContent
            category={category}
            icon={icon}
            text={text}
            value={3}
          />
        </div>
      </div>

      <style jsx>{`
        .switch {
          padding: 5px 0;
        }
        .preview {
          background-color: white;
          border-radius: ${theme.cardBorderRadius};
          margin-top: 10px;
          padding: 15px;
        }
        .preview-disabled {
          opacity: 0.8;
        }
        .content {
          transform: scale(0.95);
        }
      `}</style>
    </div>
  );
};

export default HomePageSettingsSummaryCount;
